import React from 'react'
import { connect } from 'react-redux'
import { defaultTo } from 'lodash'

import { fetchDebtors, clearDebtor } from '../../actions/remote_api'
import SearchSelect from '../../modules/select/SearchSelect'

class DebtorSearchSelect extends React.Component {
  render() {
    return (
      <SearchSelect
        {...this.props}
        options={this.props.options}
        createQuery={defaultTo(this.props.createQuery, createQuery)}
        createLabel={createLabel}
        defaultValueQuery={defaultValueQuery}
        selectId="debtorOptions"
      />
    )
  }
}

const createQuery = (searchText) => ({
  name_like: searchText ? searchText.toLowerCase() : undefined,
})

const defaultValueQuery = (initialId) => ({
  _id: initialId,
})

const createLabel = (a) => a.name

export default connect(null, {
  fetchOptions: fetchDebtors,
  clearOptions: clearDebtor,
})(DebtorSearchSelect)
